<template>
    <MainContainer background="darkGreyPartial">
        <div class="col-xs-12 col-sm-8 col-md-7 col-lg-5 center tc mv5">
            <div class="pv4 ph3 bg-white custom-shadow">
                <Login :showBackButton="false" @forgotClick="$router.push($route.query.redirect)" />
            </div>
        </div>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import Login from '@/components/header/nav-items/Login.vue';

export default {
    components: {
        MainContainer,
        Login
    }
};
</script>
